// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+cSFp","main-image":"Header_main-image__K-d32"};